import { useMemo } from 'react';
import { getMapBy } from '../common/utils';
import { useSystemClassifiers } from '../configuration';
import { SystemClassifierItemDto } from '../systemClassifier';

export const useClassifierDataTypesBy = <
  K extends keyof SystemClassifierItemDto
>(
  key: K
) => {
  const { CLASSIFIER_DATA_TYPE } = useSystemClassifiers('CLASSIFIER_DATA_TYPE');

  return useMemo(
    () => getMapBy(CLASSIFIER_DATA_TYPE.systemClassifierItems, key),
    [CLASSIFIER_DATA_TYPE]
  );
};
